<template>
    <svg width="72" height="72" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(0 14)">
            <rect x="16" width="4" height="30" rx="2" />
            <rect x="52" width="4" height="30" rx="2" />
            <path
                d="M0 21.99A4 4 0 0 1 4 18h64c2.21 0 4 1.784 4 3.99v16.02A4 4 0 0 1 68 42H4c-2.21 0-4-1.784-4-3.99V21.99z"
            />
            <g transform="translate(16 28)" fill="#FFF">
                <rect width="4" height="4" rx="2" />
                <rect x="12" width="4" height="4" rx="2" />
                <rect x="24" width="4" height="4" rx="2" />
                <rect x="36" width="4" height="4" rx="2" />
            </g>
        </g>
    </svg>
</template>